// extracted by mini-css-extract-plugin
export default {"referal_container":"Referal_referal_container__ezjQg","form":"Referal_form__6pca8","form_input":"Referal_form_input__YHacS"};